import React, { useEffect, useState } from "react";
import { getDatabase, ref, onValue } from "firebase/database";

const Banner = () => {
  const [closestEvent, setClosestEvent] = useState(null);
  const [countdown, setCountdown] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  });
  const [activeSlide, setActiveSlide] = useState(0);

  // IMAGE HELPER (custom → preset → fallback)
  const renderEventImage = (event, key = "banner") => {
    const type = (event.EVENT_TYPE || "other").toLowerCase();
     const type2 = (event.EVENT_TYPE || "other");
    const imgNUM = event.EVENT_IMAGENUM || "";
    const customImage = event.EVENT_IMAGE || null;

    const imageMap = {
      race: `race${imgNUM}`,
      rally: `rally${imgNUM}`,
      meetup: `meetup${imgNUM}`,
      drag: `drag${imgNUM}`,
      drift: `drift${imgNUM}`,
      trackday: `trackday${imgNUM}`,
      motorbike: `motorbike${imgNUM}`,
      other: `other${imgNUM}`,
    };

    const presetImg = imgNUM ? imageMap[type] || imageMap.other : null;

    if (customImage) {
      return (
        <img
          src={`../assets/img/uploads/events/${event.EVENT_IMAGE}.png`}
          alt={event.EVENT_NAME}
          className="event-image"
          style={{ maxWidth: "100%" }}
          loading="lazy"
        />
      );
    }

    if (presetImg) {
      return (
        <img
          src={`../assets/img/${type}/${presetImg}-1024.png`}
          srcSet={`
            ../assets/img/${type}/${presetImg}-480.png 480w,
            ../assets/img/${type}/${presetImg}-640.png 640w,
            ../assets/img/${type}/${presetImg}-1024.png 1024w,
            ../assets/img/${type}/${presetImg}-1600.png 1600w,
            ../assets/img/${type}/${presetImg}-2400.png 2400w
          `}
          alt={event.EVENT_NAME}
          className="event-image"
          style={{ maxWidth: "100%" }}
          loading="lazy"
        />
      );
    }

    return <div className={`event-image-fallback-banner event-image-${type2}`}></div>;
  };

  // Fetch events
  useEffect(() => {
    const db = getDatabase();
    const eventsRef = ref(db, "EVENTS/EVENT/AUTOMOTIVE");

    const unsubscribe = onValue(eventsRef, (snapshot) => {
      const data = snapshot.val();

      if (!data) {
        setClosestEvent(null);
        return;
      }

      const allEvents = Object.values(data);

      // Find closest upcoming event
      let minDiff = Infinity;
      let closest = null;
      const now = new Date();

      allEvents.forEach((event) => {
        if (!event.EVENT_DATE) return;
        if (event.EVENT_PUBLIC !== "Y") return;

        const [day, month, year] = event.EVENT_DATE.split("/");
        const eventDate = new Date(`${year}-${month}-${day}T00:00:00`);
        const diff = eventDate - now;

        if (diff >= 0 && diff < minDiff) {
          minDiff = diff;
          closest = { ...event, eventDate };
        }
      });

      setClosestEvent(closest);
    });

    return () => unsubscribe();
  }, []);

  // Countdown timer
  useEffect(() => {
    if (!closestEvent) return;

    const interval = setInterval(() => {
      const now = new Date();
      const diff = closestEvent.eventDate - now;

      if (diff <= 0) {
        setCountdown({ days: 0, hours: 0, minutes: 0, seconds: 0 });
        clearInterval(interval);
        return;
      }

      const days = Math.floor(diff / (1000 * 60 * 60 * 24));
      const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
      const minutes = Math.floor((diff / (1000 * 60)) % 60);
      const seconds = Math.floor((diff / 1000) % 60);

      setCountdown({ days, hours, minutes, seconds });
    }, 1000);

    return () => clearInterval(interval);
  }, [closestEvent]);

  const slides = [];

  // Closest upcoming event
  if (closestEvent) {
    slides.push(
      <div key="closest" className="event-row">
        <div className="event-image-wrapper">
          {renderEventImage(closestEvent, "closest")}
        </div>
        <div className="event-info-card">
          <div className="mb-2 eventbanner-upcoming">Upcoming Event</div>
          <h2 className="eventbanner-header">{closestEvent.EVENT_NAME}</h2>
          <p className="mb-2">
            <span className="countdown-time fw-medium text-gray-500">
              {countdown.days} <span className="countdown-text">Days</span>
            </span>{" "}
            <span className="countdown-time fw-medium text-gray-500">
              {countdown.hours} <span className="countdown-text">Hours</span>
            </span>{" "}
            <span className="countdown-time fw-medium text-gray-500">
              {countdown.minutes}{" "}
              <span className="countdown-text">Minutes</span>
            </span>{" "}
            <span className="countdown-time fw-medium text-gray-500">
              {countdown.seconds}{" "}
              <span className="countdown-text">Seconds</span>
            </span>
          </p>
          <p className="location eventbanner-location user-select-all">
            {closestEvent.EVENT_LOCATION}, {closestEvent.EVENT_POSTCODE}
          </p>
        </div>
      </div>
    );
  }



  const nextSlide = () =>
    setActiveSlide((prev) => (prev + 1) % slides.length);
  const prevSlide = () =>
    setActiveSlide((prev) => (prev - 1 + slides.length) % slides.length);

  if (slides.length === 0) return null;

  return (
    <div className="banner-carousel position-relative py-5 banner3 desktop-show">
      <div className="container-sm text-center">
        <div className="position-relative d-inline-block">
          <div className="d-flex justify-content-center">
            {slides[activeSlide]}
          </div>
          {slides.length > 1 && (
            <>
              <button
                onClick={prevSlide}
                className="position-absolute top-50 start-10 translate-middle-y banner-btn-left"
                style={{ zIndex: 10 }}
              >
                <i className="bi bi-chevron-left"></i>
              </button>
              <button
                onClick={nextSlide}
                className="position-absolute top-50 end-10 translate-middle-y banner-btn-right"
                style={{ zIndex: 10 }}
              >
                <i className="bi bi-chevron-right"></i>
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default Banner;